import { AgreementStateEnum, type Agreements } from '../agreement';
import { getEnabledAgreements } from '../agreementSelection';
import type { SearchParameters } from '../searchParameters';

// TODO(agreementPredicates): extract to a shared agreementPredicates.ts once
// more agreement-related boolean checks accumulate (per !5344 review).
const isPremiumAccessEnabled = (searchParameters: SearchParameters): boolean =>
  !!searchParameters.agreements?.premiumaccess;

// The exhausted and view-only checks apply only when the search has a
// premium-access agreement selected; with none selected, an asset is never
// treated as exhausted or view-only. `getEnabledAgreements` returns no
// `paAgreement` in that case — anything falling back to the first held
// agreement would apply the check too widely.
//
// Both are exported within the concept, for getDownloadOffer and
// canBatchDownload.
export const isPaExhausted = (
  agreements: Agreements,
  searchParameters: SearchParameters
): boolean => {
  if (!isPremiumAccessEnabled(searchParameters)) return false;
  const { paAgreement } = getEnabledAgreements(agreements, searchParameters);
  return (
    (paAgreement?.isExhausted() ?? false) || agreements.areAllPaExhausted()
  );
};

export const isPaViewOnly = (
  agreements: Agreements,
  searchParameters: SearchParameters
): boolean => {
  if (!isPremiumAccessEnabled(searchParameters)) return false;
  const { paAgreement } = getEnabledAgreements(agreements, searchParameters);
  return (
    paAgreement?.state === AgreementStateEnum.ViewOnly ||
    agreements.areAllPaViewOnly()
  );
};
